import { Box, Radio } from '@mantine/core'

const ApplicationRadioQuestion = ({
  question,
  defaultValue = undefined,
  value,
  handleChange,
  // Settings-page row variant (desktop rail layout, ENG-4358): question label
  // left, Yes/No compactly on the right, vertically centered. The default
  // stacked rendering is byte-identical when this is false.
  inline = false,
  ...props
}) => {
  return (
    <div className="flex w-full flex-col items-start">
      <Radio.Group
        label={question}
        defaultValue={defaultValue}
        value={value}
        classNames={{
          root: inline
            ? 'flex flex-row items-center justify-between gap-6 w-full'
            : 'flex flex-col w-full',
          label: inline
            ? 'text-sm font-medium text-doubleNickel-gray-600'
            : 'text-sm font-medium text-doubleNickel-gray-600 min-h-11 pb-2',
        }}
        {...props}
      >
        <div
          className={`flex flex-row gap-3 ${inline ? 'w-[220px] flex-none' : ''}`}
        >
          <Box
            onClick={() => handleChange('true')}
            className={`shadow-xs flex-1 rounded-lg  border px-4 py-3 hover:border-doubleNickel-brand-500 ${
              value === 'true'
                ? 'border-doubleNickel-brand-500'
                : 'border-doubleNickel-gray-300'
            }`}
          >
            <Radio value="true" label="Yes" />
          </Box>
          <Box
            onClick={() => handleChange('false')}
            className={`shadow-xs flex-1 rounded-lg border px-4 py-3 hover:border-doubleNickel-brand-500 ${
              value === 'false'
                ? 'border-doubleNickel-brand-500'
                : 'border-doubleNickel-gray-300'
            }`}
          >
            <Radio value="false" label="No" />
          </Box>
        </div>
      </Radio.Group>
    </div>
  )
}

export default ApplicationRadioQuestion
